import { IconExplore } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'

import { TooltipWrapper } from '~/portal/components/TooltipWrapper'
import { useUser } from '~/portal/hooks/useUser'

interface ExplorePluginButtonProps {
  path?: any, // Immutablejs object
  swaggerhubOrgName: string,
  version: string,
  exploreUrl: string,
  swaggerhubApiName: string,
  oasVersion: string
}

export const ExplorePluginButton = ({ path, swaggerhubOrgName, version, exploreUrl, swaggerhubApiName, oasVersion }: ExplorePluginButtonProps) => {
  const { t } = useTranslation()
  const { isLoggedIn, user } = useUser()

  if (user?.isExternal) {
    return null
  }

  if (!path?.get || path?.get(0) !== 'paths') {
    return null
  }

  const pathName = path?.get(1)
  const method = path?.get(2)

  // Explore supports only OpenAPI 3.0 definitions
  const isOpenApi3_0 = oasVersion.startsWith('3.0')

  if (!pathName || !method || !isOpenApi3_0) {
    return null
  }

  return (
    <TooltipWrapper
      content={isLoggedIn ? t('components.ui.apiViewer.explore.tooltip.userLoggedIn') : t('components.ui.apiViewer.explore.tooltip.userNotLoggedIn')}
      trigger="hover"
      defaultComp={
        <a
          href={`${exploreUrl}/catalog?owner=${swaggerhubOrgName}&api=${swaggerhubApiName}&version=${version}&path=${pathName}&method=${method}`}
          target="_blank"
          className="flex items-center justify-center w-6 h-6 transition duration-100 ease-in rounded hover:bg-(--sp-color-surface-hover) text-(--sp-color-text-muted)"
          rel="noreferrer" >
          <IconExplore />
        </a>
      }
      placement="top"
      portalSelector="body"
    />
  )
}